"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CouponType = exports.MediaItemType = void 0;
var MediaItemType;
(function (MediaItemType) {
    MediaItemType["image"] = "image";
    MediaItemType["video"] = "video";
    MediaItemType["audio"] = "audio";
    MediaItemType["document"] = "document";
    MediaItemType["zip"] = "zip";
})(MediaItemType = exports.MediaItemType || (exports.MediaItemType = {}));
var CouponType;
(function (CouponType) {
    CouponType["BuyXGetY"] = "BuyXGetY";
    CouponType["FixedPrice"] = "FixedPrice";
    CouponType["FreeShipping"] = "FreeShipping";
    CouponType["MoneyOff"] = "MoneyOff";
    CouponType["PercentOff"] = "PercentOff";
})(CouponType = exports.CouponType || (exports.CouponType = {}));
//# sourceMappingURL=defenitions.js.map